I18n.translations || (I18n.translations = {});
I18n.translations["de"] = I18n.extend((I18n.translations["de"] || {}), {
  "errors": {
    "messages": {
      "invalid_recaptcha": "Ungültiges Recaptcha. Versuche die Seite neu zu laden.",
      "summary": "Bitte prüfe folgende Eingaben: %{fields}."
    }
  },
  "misc": {
    "close": "Schließen",
    "required_field": "Pflichtfeld"
  },
  "recurring_donation_job": {
    "header": {
      "banner_hint": "Mehr Infos",
      "banner_text": "Mach eine monatliche Dauerspende für dieses Projekt und wir verdoppeln deine Spende!",
      "explanation_html": "<ul>\n  <li>Du legst im Aktionszeitraum (12.11.-30.11.2019) eine monatliche Dauerspende für die teilnehmenden Projekte auf betterplace.org an.</li>\n  <li>Wir verdoppeln deine Spende einmalig, nachdem sie zum dritten Mal eingegangen ist. Brichst du deine Dauerspende vorher ab, können wir nicht verdoppeln.</li>\n  <li>Wir verdoppeln so lange Spenden, bis unser Topf von 10.000 EUR aufgebraucht ist.</li>\n  <li>Pro Spender*in pro Projekt werden maximal 200 EUR verdoppelt. Gerne kannst du natürlich für mehrere Projekte monatliche Dauerspenden einrichten!</li>\n</ul>"
    }
  },
  "shared": {
    "data_transfer_popover_html": "<strong>Abmeldung jederzeit möglich</strong><br/><br/>\n\nFolgende Daten werden an „%{name}“ weitergeben:<br/><br/>\n\n<ul>\n  <li>Zeitpunkt der Spenden</li>\n  <li>Spendenbetrag in Euro</li>\n  <li>Projekt</li>\n  <li>Bedarf</li>\n  <li>Vorname</li>\n  <li>Nachname</li>\n  <li>Firmenname falls vorhanden</li>\n  <li>E-Mail</li>\n  <li>Straße / Hausnummer</li>\n  <li>PLZ</li>\n  <li>Ort</li>\n  <li>Spenden - Intervall</li>\n</ul><br/>\n<hr/>\n%{name}<br/>\n%{street}<br/>\n%{zip} %{city}",
    "tax_deductibility_notice_html": "Du erhältst eine Spendenbescheinigung vom <u style='cursor: pointer;'>Spendenempfänger</u> betterplace (gut.org gAG)."
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "errors": {
    "messages": {
      "invalid_recaptcha": "Invalid recaptcha. Try reloading the page.",
      "summary": "Please validate your %{fields}."
    }
  },
  "misc": {
    "close": "Close",
    "required_field": "required"
  },
  "recurring_donation_job": {
    "header": {
      "banner_hint": "More info",
      "banner_text": "Start a monthly recurring donation for this project and we will double your donation!",
      "explanation_html": "<ul>\n  <li>During the campaign period (12.11.-30.11.2019) you make a monthly recurring donation to the participating projects on betterplace.org.</li>\n  <li>We will double your donation once after it has been received for the third time. If you cancel your recurring donation beforehand, we will not be able to double it.</li>\n  <li>We double donations until our pool of 10.000 EUR is used up.</li>\n  <li>Per donor per project a maximum of 200 EUR will be doubled. Of course, you can set up monthly donations for several projects!</li>\n</ul>"
    }
  },
  "shared": {
    "data_transfer_popover_html": "<strong>You can unsubscribe at any time</strong><br/><br/>\n\nThe following data will be forwarded to “%{name}“:<br/><br/>\n\n<ul>\n  <li>Time of donation</li>\n  <li>Amount donated in Euro</li>\n  <li>Project</li>\n  <li>Need</li>\n  <li>First name</li>\n  <li>Surname</li>\n  <li>Company name if provided</li>\n  <li>Email</li>\n  <li>Address</li>\n  <li>Postcode</li>\n  <li>Donation interval</li>\n</ul><br/>\n<hr/>\n%{name}<br/>\n%{street}<br/>\n%{zip} %{city}",
    "tax_deductibility_notice_html": "You will receive a donation receipt from betterplace (gut.org gAG), the initial <u style='cursor: pointer;'>recipient of the donation</u>."
  }
});
